import { MatLabel } from '@angular/material/form-field';
import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { FilterOptions, FilterBuilder, FilterComponent, FilterFormComponent, MgFormControlDirective } from '@mango/core';
import { User } from './user';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'mtp-user-filter',
    templateUrl: './user-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FilterFormComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatIconButton, MatSuffix, MatIcon]
})
export class UserFilterComponent extends FilterComponent<User>  {

    constructor(injector: Injector) {
        super(User, new FilterOptions<User>().like("name"));
    }

    ngOnInit() {
        super.ngOnInit();
    }
} 